// ─── Sentry helpers (no-op gracefully if SDK unavailable) ───
// We avoid sending PII (email/name) — instead, hash the email to a stable opaque id
// so we can correlate events without exposing identity.
const _djb2 = (str) => {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) | 0;
  return (h >>> 0).toString(36);
};
const _hashEmail = (email) => email ? "u_" + _djb2(String(email).toLowerCase().trim()) : null;

export const SentryUtil={
  // Call once user signs in — attaches a hashed id (NOT email) to future errors
  identify:(email,name)=>{
    if(typeof Sentry==="undefined")return;
    const id=_hashEmail(email);
    if(!id)return;
    Sentry.setUser({id});
  },
  // Clear on sign-out
  reset:()=>{if(typeof Sentry!=="undefined")Sentry.setUser(null);},
  // Wrap an async fn so thrown errors are captured with context
  capture:(err,context)=>{
    if(typeof Sentry==="undefined"){console.error(err);return;}
    Sentry.withScope(scope=>{
      if(context)Object.entries(context).forEach(([k,v])=>scope.setExtra(k,v));
      Sentry.captureException(err);
    });
  },
  // Track a named breadcrumb (e.g. "user saved workout")
  breadcrumb:(msg,category,data)=>{
    if(typeof Sentry==="undefined")return;
    Sentry.addBreadcrumb({message:msg,category:category||"app",data,level:"info"});
  },
};

// Global unhandled promise rejection → Sentry (covers fetch failures, etc.)
// HMR-safe: avoid re-registering on hot reload.
if(typeof window!=="undefined" && !window.__ironlogUnhandledRejectionInstalled){
  window.__ironlogUnhandledRejectionInstalled=true;
  window.addEventListener("unhandledrejection",e=>{
    if(typeof Sentry==="undefined")return;
    const reason=e.reason;
    const err = reason instanceof Error ? reason : new Error(typeof reason==="string"?reason:JSON.stringify(reason||{}));
    Sentry.captureException(err);
  });
}
